/**
 * Created by rickborst on 01/03/2017.
 */

export {getConfig, updateDeviceID} from './config';
export {
    authenticateWithCredentials,
    checkUserExistance,
    authenticateWithRefreshToken,
    logout,
    anonymousLogin,
    resetPassword,
    setPasswordWithToken
} from './authentication';
export {getSession, updateSession, clearSession} from './session';
export {
    getDevices,
    addDevice,
    deleteDevice,
    deleteDevices,
    verifyDevice
} from './devices';
export {
    getActiveUser,
    updateUser,
    registerUser,
    getEntitlements,
    getSubscriptions,
    getPaymentMethod,
    getPaymentDetails,
    changePassword,
    createHousehold
} from './users';
export {
    fetchViews,
    getView,
    getViewByName,
    getDiscoverNameByAsset,
    getViewBackground
} from './views';
export {getSettings, connectDevice} from './settings';
export {getTopNavigation} from './navigation';
export {getAsset} from './assets';
export {
    listPaymentGateways,
    configurePaymentGateway,
    transactionPurchase,
    productPriceList,
    addPaymentMethod,
    addCard,
    cancelPayment,
    getPaymentHistory
} from './payment';
export {getBookmarks} from './bookmark';
export {getServerTime} from './servertime';

export {loadRailAssets, prepareRails as getRails} from './rails';

export {getLinearChannels} from './linearchannels';
export {getSeriesPage} from './pages/series';
export {getEpgChannels, getEpgSection} from './epg';
export {setReminder, removeReminder, getReminder} from './reminder';
export {getLandingPage} from './landingpage';



// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/index.js